module.exports = __webpack_public_path__ + "img/live-rtmp-tutorial-4.28b99fa0.png";